// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/cjs.js??ref--5-1!../../../node_modules/.store/postcss-loader@2.1.6/node_modules/postcss-loader/lib/index.js??ref--5-2!./index.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/.store/vue-style-loader@3.1.2/node_modules/vue-style-loader/lib/addStylesClient.js")("01f004f4", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/components/ef/index.css
// module id = BfoZ
// module chunks = 0